import { render, staticRenderFns } from "./Trust.vue?vue&type=template&id=397de96a&scoped=true"
import script from "./Trust.vue?vue&type=script&lang=js"
export * from "./Trust.vue?vue&type=script&lang=js"
import style0 from "./Trust.vue?vue&type=style&index=0&id=397de96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397de96a",
  null
  
)

export default component.exports